(() => {
  const init = (root) => {
    if (!root || root.dataset.hxrReady === 'true') return;
    root.dataset.hxrReady = 'true';

    root.querySelectorAll('[data-hxr-protected] img').forEach((image) => {
      image.setAttribute('draggable', 'false');
    });

    const track = root.querySelector('[data-hxr-track]');
    const slides = Array.from(root.querySelectorAll('.hx-results__slide'));
    const current = root.querySelector('[data-hxr-current]');
    let scrollTimer = null;

    const updateCurrent = () => {
      if (!track || !slides.length || !current) return;

      const trackLeft = track.getBoundingClientRect().left;
      let nearest = 0;
      let distance = Infinity;

      slides.forEach((slide, index) => {
        const nextDistance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });

      current.textContent = String(nearest + 1).padStart(2, '0');
    };

    if (track) {
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateCurrent, 60);
      }, { passive: true });

      window.addEventListener('resize', updateCurrent, { passive: true });
      updateCurrent();
    }

    root.addEventListener('contextmenu', (event) => {
      if (event.target.closest('[data-hxr-protected]')) event.preventDefault();
    });

    root.addEventListener('dragstart', (event) => {
      if (event.target.closest('[data-hxr-protected]')) event.preventDefault();
    });
  };

  const run = (scope = document) => {
    scope.querySelectorAll('[data-hxr]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
